import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const CustomDialog = ({
  open,
  onClose,
  title,
  children,
  actions,
  width,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{ paper: { elevation: 1 } }}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 1,
          width: width ? width : "640px",
        },
      }}
    >
      <DialogTitle sx={{}}>
        <div className="text-lg font-bold"> {title}</div>

        <IconButton
          onClick={onClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>{children}</DialogContent>

      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};
